import { createAsyncThunk } from "@reduxjs/toolkit";
import { fetchCampaignRequirement as fetchCampaignRequirementAPI } from "services/api/campaign";
import { AuthState } from "slices/auth/reducer";
import { ERROR } from "types";
import { CampaignRequirementResponse } from "types/campaign/requirement";
import { getErrorMessage } from "utils/helpers";
import { handleInfluencerLocationData } from "./utils";

export const fetchCampaignRequirement = createAsyncThunk<CampaignRequirementResponse, string, { rejectValue: string }>(
    'campaign/requirement/fetch',
    async (campaignId, { getState, rejectWithValue }) => {
        const state = getState() as { auth: AuthState };
        try {
            const requirements = await fetchCampaignRequirementAPI(state.auth.selectedAgencyId!, campaignId);
            return handleInfluencerLocationData(requirements);
        } catch (error) {
            return rejectWithValue(getErrorMessage(error, ERROR.NOT_FOUND));
        }
    }
)